module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgetPwd"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": _vm.checkUsername,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱（注册时填写）"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": _vm.checkEmail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verification_code),
      expression: "verification_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verification_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verification_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "发送验证码至邮箱"
    },
    on: {
      "click": _vm.sendEmail
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": _vm.update
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("忘记密码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73efaaa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgetPwd.vue
// module id = 624
// module chunks = 1